import React from 'react';
import Styled from './styles';

export interface UtilityDrawerSectionProps extends React.ComponentPropsWithRef<'div'> {
  /** Place content here. */
  children: React.ReactNode;
}

/** Right aligned content of Utility Drawer. All props other than 'children' will be forwarded to root element.  */
const UtilityDrawerSection = React.forwardRef<HTMLElement, UtilityDrawerSectionProps>((props: UtilityDrawerSectionProps, ref) => {
  const {
    children,
    ...otherProps
  } = props;
  return (
    <Styled.UtilityDrawerSection ref={ref} {...otherProps}>
      {children}
    </Styled.UtilityDrawerSection>
  );
});

UtilityDrawerSection.displayName = 'UtilityDrawerSection';

export default UtilityDrawerSection;
